import { render } from "./InternalServerError.vue?vue&type=template&id=386c39d5&scoped=true&ts=true"
import script from "./InternalServerError.vue?vue&type=script&lang=ts"
export * from "./InternalServerError.vue?vue&type=script&lang=ts"

import "./InternalServerError.vue?vue&type=style&index=0&id=386c39d5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386c39d5"]])

export default __exports__